import React from "react";
import { CSVLink, CSVDownload } from "react-csv";
import { Assessment3bFuelTypeInfo } from "../state";


interface Assessment3bDownloadCSVProps {
    fuelTypes: Assessment3bFuelTypeInfo[];
}

function Assessment3bDownloadCSV({ fuelTypes }: Assessment3bDownloadCSVProps) {
    const csvData = [["Fuel", "Issue", "Action Plan"]];
        let rowIndex:number = 1;
        //iterate fuel types
        fuelTypes.map(fuel => {
            if(fuel.appVendorNameAndAccountNoDesc !== null
                && fuel.appVendorNameAndAccountNoDesc !== '')
            {
                csvData[rowIndex] = ["You must acquire electric billing data on households that heat with fuels other than electricity."
                                      , fuel.description
                                      , fuel.appVendorNameAndAccountNoDesc];
                rowIndex++; 
            }
            if(fuel.clientWaiversMeetElectricVendorRequirementsDesc !== null
                && fuel.clientWaiversMeetElectricVendorRequirementsDesc !== '')
            {
                csvData[rowIndex] = ["Communicate with your vendors to ensure your waivers meet their requirements."
                                      , fuel.description
                                      , fuel.clientWaiversMeetElectricVendorRequirementsDesc];
                rowIndex++; 
            }
            if(fuel.electricVendorRequestedServeTargetPercentHhDesc !== null
                && fuel.electricVendorRequestedServeTargetPercentHhDesc !== '')
            {
                csvData[rowIndex] = ["Keep track of the number of LIHEAP clients served by each vendor and each vendor’s compliance history."
                                      , fuel.description
                                      , fuel.electricVendorRequestedServeTargetPercentHhDesc];
                rowIndex++; 
            }
            if(fuel.electricVendorProvidedServeTargetPercentHhDesc !== null
                && fuel.electricVendorProvidedServeTargetPercentHhDesc !== '')
            {
                csvData[rowIndex] = ["You must request data from vendors representing more than enough clients."
                                      , fuel.description
                                      , fuel.electricVendorProvidedServeTargetPercentHhDesc];
                rowIndex++; 
            }
            if(fuel.electricBillingDataTargetPercentHhDesc !== null
                && fuel.electricBillingDataTargetPercentHhDesc !== '')
            {
                csvData[rowIndex] = ["You must request data from vendors representing more than enough clients so that vendors representing enough clients will comply."
                                      , fuel.description
                                      , fuel.electricBillingDataTargetPercentHhDesc];
                rowIndex++; 
            }
            if(fuel.vendorsSupplyDataNonElectricHhDesc !== null
                && fuel.vendorsSupplyDataNonElectricHhDesc !== '')
            {
                csvData[rowIndex] = ["You must acquire electric billing data on households that heat with fuels other than electricity."
                                      , fuel.description
                                      , fuel.vendorsSupplyDataNonElectricHhDesc];
                rowIndex++; 
            }
            if(fuel.otherReasonMainHeatDesc !== null
                && fuel.otherReasonMainHeatDesc !== '')
            {
                csvData[rowIndex] = ["Other reasons for your potential data reliability issue."
                                      , fuel.description
                                      , fuel.otherReasonMainHeatDesc];
                rowIndex++; 
            }
            if(fuel.clientWaiversMeetHeatVendorRequirementsDesc !== null
                && fuel.clientWaiversMeetHeatVendorRequirementsDesc !== '')
            {
                csvData[rowIndex] = ["For   " + fuel.description + "   vendors to send you billing data, they must receive satisfactory privacy waivers."
                                      , fuel.description
                                      , fuel.clientWaiversMeetHeatVendorRequirementsDesc];
                rowIndex++; 
            }
            if(fuel.heatVendorRequestedServeTargetPercentHhDesc !== null
                && fuel.heatVendorRequestedServeTargetPercentHhDesc !== '')
            {
                csvData[rowIndex] = ["If you do not request data on more than " + fuel.targetPercentHouseholdsCoveredString + " of households, you cannot acquire data that meets this threshold."
                                      , fuel.description
                                      , fuel.heatVendorRequestedServeTargetPercentHhDesc];
                rowIndex++; 
            }
            if(fuel.heatVendorProvidedServeTargetPercentHhDesc !== null
                && fuel.heatVendorProvidedServeTargetPercentHhDesc !== '')
            {
                csvData[rowIndex] = ["You must request data from vendors representing more than enough clients so that vendors representing enough clients will comply."
                                      , fuel.description
                                      , fuel.heatVendorProvidedServeTargetPercentHhDesc];
                rowIndex++; 
            }
            if(fuel.heatBillingDataTargetPercentHhDesc !== null
                && fuel.heatBillingDataTargetPercentHhDesc !== '')
            {
                csvData[rowIndex] = ["Compliant vendors are not supplying complete data on enough clients."
                                      , fuel.description
                                      , fuel.heatBillingDataTargetPercentHhDesc];
                rowIndex++; 
            }
            if(fuel.heatBillingDataIncluesAcctNoDesc !== null
                && fuel.heatBillingDataIncluesAcctNoDesc !== '')
            {
                csvData[rowIndex] = ["You must know the main heating vendor and account number of each LIHEAP participating household."
                                      , fuel.description
                                      , fuel.heatBillingDataIncluesAcctNoDesc];
                rowIndex++; 
            }
            if(fuel.electricBillingDataIncluesAcctNoDesc !== null
                && fuel.electricBillingDataIncluesAcctNoDesc !== '')
            {
                csvData[rowIndex] = [" You must know the electric vendor and account number of each LIHEAP participating household"
                                      , fuel.description
                                      , fuel.electricBillingDataIncluesAcctNoDesc];
                rowIndex++; 
            }
            if(fuel.hhUniqueIdAssignedDesc !== null
                && fuel.hhUniqueIdAssignedDesc !== '')
            {
                csvData[rowIndex] = ["If you cannot match this data to clients, you will not have accurate estimates of the energy expenditures of LIHEAP participating households."
                                      , fuel.description
                                      , fuel.hhUniqueIdAssignedDesc];
                rowIndex++; 
            }
            if(fuel.otherReasonMatchingDesc !== null
                && fuel.otherReasonMatchingDesc !== '')
            {
                csvData[rowIndex] = ["Other potential explanations for this discrepancy."
                                      , fuel.description
                                      , fuel.otherReasonMatchingDesc];
                rowIndex++; 
            }


        });
    return (
      <CSVLink data={csvData} filename="ElectricBaseloadAssessment3b.csv" className="dataButton">Download as CSV</CSVLink>
    );
}


export default Assessment3bDownloadCSV;
